// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SESSION_ID } from '../../../../../config/session-id';
import { Captcha } from '../../../../components/captcha/captcha.model';

/** @ngInject */
export function Controller(
    $http,
    $scope,
    $state,
    AuthenticationSharedService,
    BarcodeGeneratonService,
    EmailVerificationDataService,
) {
    const $ctrl = this;
    $scope.displaySpinner = true;
    $ctrl.message = [];
    const captcha = $scope.captcha = new Captcha({
        isVisible: () => $scope.attempts >= 5
    });
    var INFO = "INFO";
    var ERROR = "ERROR";
    var SUCCESS = "SUCCESS";

    $scope.icon = INFO;
    $scope.showVerificationForm = true;
    $scope.showIframe = false;

    // gets vkey attribute from query string
    $scope.vkey = $state.params.vkey;

    // e-mail verification on page load
    EmailVerificationDataService.get({
        vkey : $scope.vkey
    }, function(data) {
        $scope.displaySpinner = false;
        if (!data.verificationRequired) {
            // E-mail verified
            $scope.vkey = null;
            $ctrl.message = [data.message];
            $scope.showVerificationForm = false;
            $scope.icon = SUCCESS;
            $scope.showIframe = false;
        } else {
            // Show credentials page
            $scope.showIframe = true;
            $scope.showVerificationForm = true;
            $scope.icon = INFO;
            $scope.verificationType = data.emailVerificationType;
            $scope.isCompanyVerification = false;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $scope.isCompanyVerification = true;
            }
           /* if ($scope.icon = SUCCESS) {
                $scope.showIframe = false;
            }*/
            $scope.attempts = data.numberOfAttempts;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $ctrl.message = ['email_verification_data.messages.verification.company'];
            } else if ($scope.verificationType == 'EMAIL_VERIFICATION')
                $ctrl.message = ['email_verification_data.messages.verification.user'];
            
            else {
                $ctrl.message = [data.message, 'email_verification_data.messages.verification.user'];
            }
        }
    }, function(error) {
        // Error on verifying e-mail. Do not show credentials page
        $scope.displaySpinner = false;
        $scope.icon = ERROR;
        $scope.verificationType = error.data.emailVerificationType;
        if ($scope.verificationType == 'COMPANY_VERIFICATION') {
            $scope.isCompanyVerification = true;
        } else {
            $scope.isCompanyVerification = false;
        }
        $scope.showVerificationForm = false;
        $ctrl.message = [error.data.message];
        $scope.message2 = error.data.secondaryMessage;
    });
    
    $scope.verify = function() {
        $scope.trackerId = null;
        sendVerificationRequestWithCredentials();
        $('html, body').animate({ scrollTop:0 }, 'slow');
    };

    // e-mail after credentials are submited
    function sendVerificationRequestWithCredentials() {
        const url = 'app/rest/emailverificationdata/credentialcheck';
        var requestBody = {};
        requestBody.vkey = $scope.vkey;
        requestBody.saaspassId = $scope.username;
        requestBody.verificationType = $scope.verificationType;
        if ($scope.password) {
            requestBody.otp = $scope.password;
        } else {
            requestBody.trackerId = $scope.trackerId;
        }

        requestBody.captchaResponse = captcha.response;

        $scope.authenticationError = false;
        $scope.captchaError = false;
        $http.post(url, requestBody).then((response) => {
            const data = response.data;
            // Email verified
            if($scope.verificationType=='COMPANY_VERIFICATION') {
                AuthenticationSharedService.loginAfterRegistration({
                    username : $scope.username,
                    password : data.companyTracker,
                    companyId : data.companyId,
                });
            } else {
                $scope.icon = SUCCESS;
                $ctrl.message = [data.message];
                $scope.message2 = data.secondaryMessage;
                $scope.showVerificationForm = false;
            }
        }).catch((response) => {
            const data = response.data;
            if (data.incorrectCredentials) {
                // incorrect credentials
                $scope.attempts = data.numberOfAttempts;
                if (data.message == "Incorrect Captcha") {
                    $scope.captchaError = true;
                } else {
                    $scope.authenticationError = true;
                }

                return;
            }
            // Error on verifying e-mail. Do not show credentials page
            $scope.icon = ERROR;
            $scope.showVerificationForm = false;
            $ctrl.message = [data.message];
            $scope.message2 = data.secondaryMessage;
        })
        .finally(() => captcha.reset());
    }

    $scope.$on('websocket.LOGIN', (event, data) => {
        $scope.trackerId = data.password;
        $scope.username = data.username;
        $scope.password = null;
        sendVerificationRequestWithCredentials();
    });

    $scope.loadQrData = () => {
        return BarcodeGeneratonService
            .get({uuid: SESSION_ID}).$promise
            .then((barcode) => {
                $scope.mobileLoginUrl = `saaspass-wa://login?barcode=${barcode.bluetoothcode}`;
                return barcode.barcodeimage;
            });
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/company/company-verification.controller.js